import React from 'react';
import Loadable from 'react-loadable';

export default Loadable({
	loader: () => import(/* webpackChunkName: 'accountswitcher' */ 'lib/components/AccountSwitcher'),
	// loading: () => <div style={{ background: 'black', height: '22px' }} />,
	loading: () => <div />
});
